var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',{staticClass:"mt-6",class:{ 'dir-rtl': _vm.isRTL },attrs:{"lang":_vm.lang}},[_vm._v(" "+_vm._s(_vm.$t('trans.admin.root.admin'))+" ")]),_c('AdminPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }